function Price() {
   return (
      <div>
         PRICE
      </div>
   );
}
export default Price;